<!-- 底部操作面板-更多操作弹窗 -->
<template>
  <div class="more-list-popup">
    <div class="container">
      <div class="list row">
        <div v-for="(item, index) in moreList" :key="index" class="item"
          @click="$goFundApp">
          <img :src="item.image" class="icon"/>
          <div>{{item.title}}</div>
        </div>
      </div>
      <div class="cancel" @click="() => { this.$emit('cancel')}">取消</div>
    </div>
  </div>
</template>

<script>
import moreListUtil from '@/utils/more-list';

export default {

  name: 'more-list-popup',

  props: {
    cfhInfo: {
      type: Object,
      default: () => ({}),
    },
    basicInfo: {
      type: Object,
      default: () => ({}),
    },
    detailInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    moreList() {
      return moreListUtil.getMoreList(
        this.detailInfo?.bottomMoreInfo || {},
        this.cfhInfo || {},
      );
    },
  },
};
</script>

<style lang="less" scoped>
.more-list-popup {
  width: 100%;
  min-height: 100px;
  position: fixed;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1001;
  .container {
    background-color: #f5f5f5;
    width: 100%;
    position: absolute;
    bottom: 0;
    height: auto;
    .list {
      background-color: #fff;
      padding: 0 8px;
      box-sizing: border-box;
      justify-content: flex-start;
      flex-wrap: wrap;
      .item {
        width: 25%;
        padding: 48px 16px 32px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        color: #000000;
        font-size: 28px;
        img {
          width: 90px;
          height: 90px;
          border-radius: 45px;
        }
      }
    }
    .cancel {
      margin-top: 28px;
      width: 100%;
      background-color: #fff;
      text-align: center;
      font-size: 32px;
      line-height: 96px;
      height: 96px;
      color: #000000;
    }
  }
}
.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
